import React, { useState } from 'react';
import { Plus } from 'lucide-react';
import EquipmentList from '../../components/admin/equipment/EquipmentList';
import EquipmentForm from '../../components/admin/equipment/EquipmentForm';
import './AdminEquipment.css';

const AdminEquipment = () => {
  const [showForm, setShowForm] = useState(false);
  const [editingEquipment, setEditingEquipment] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleAdd = () => {
    setEditingEquipment(null);
    setShowForm(true);
  };

  const handleEdit = (equipment) => {
    setEditingEquipment(equipment);
    setShowForm(true);
  };

  const handleClose = () => {
    setShowForm(false);
    setEditingEquipment(null);
  };

  const handleSave = () => {
    setRefreshKey(prev => prev + 1);
  };

  return (
    <div className="admin-equipment-page">
      <div className="admin-page-header">
        <h1 className="admin-page-title">Equipment</h1>
        <button onClick={handleAdd} className="btn btn-primary">
          <Plus size={20} />
          Add Equipment
        </button>
      </div>

      <EquipmentList 
        key={refreshKey}
        onEdit={handleEdit} 
        onAdd={handleAdd}
      />

      {showForm && (
        <EquipmentForm
          equipment={editingEquipment}
          onClose={handleClose}
          onSave={handleSave}
        />
      )}
    </div>
  );
};

export default AdminEquipment;